import { combineValidators, isRequired } from "revalidate";
import { adultPassengerNumberValidator } from "app/utils/form/fieldValidators";
import { babiesNumberMustNotExceedAdultsNumber } from "app/utils/form/validators";
import validationMessages from "app/utils/form/validationMessages.js";

export const flightAndHotelFields = [
	"offer",
	"departureCityCode",
	"departureDate",
	"duration",
	"adults",
	"children",
	"infants",
	"childrenBirthdates[].day",
	"childrenBirthdates[].month",
	"childrenBirthdates[].year",
	"infantsBirthdates[].day",
	"infantsBirthdates[].month",
	"infantsBirthdates[].year",
];

export const hotelOnlyFields = [
	"offer",
	"departureDate",
	"duration",
	"adults",
	"children",
	"infants",
	"childrenBirthdates[].day",
	"childrenBirthdates[].month",
	"childrenBirthdates[].year",
	"infantsBirthdates[].day",
	"infantsBirthdates[].month",
	"infantsBirthdates[].year",
];

export const validate = combineValidators({
	offer: isRequired({
		message: "TODO offer isRequired",
	}),
	duration: isRequired({
		message: "TODO duration isRequired",
	}),
	departureDate: isRequired({
		message: "TODO departureDate isRequired",
	}),
	adults: adultPassengerNumberValidator,
	infants: babiesNumberMustNotExceedAdultsNumber("adults")({
		message: validationMessages.babyExceedAdult,
	}),
	"childrenBirthdates[]": {
		day: isRequired({
			message: validationMessages.birthdateDayRequired,
		}),
		month: isRequired({
			message: validationMessages.birthdateMonthRequired,
		}),
		year: isRequired({
			message: validationMessages.birthdateYearRequired,
		}),
	},
	"infantsBirthdates[]": {
		day: isRequired({
			message: validationMessages.birthdateDayRequired,
		}),
		month: isRequired({
			message: validationMessages.birthdateMonthRequired,
		}),
		year: isRequired({
			message: validationMessages.birthdateYearRequired,
		}),
	},
});
